import React, { useState } from "react";
import "./InscripcionClub.css";
import Murcielago from "../pages/assets/img/imagenes club/Murcielago.png";
import BalloonBenEmergente from "../pages/assets/img/imagenes club/BalloonBenEmergente.png"

const InscripcionClub = ({ titulo = "Suscríbete al Club Balloon & Ben" }) => {
  const [formData, setFormData] = useState({
    nombre: "",
    email: "",
    pais: "",
    noticias: false,
    ofertas: false,
    politica_privacidad: false,
  });

  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setIsError(false);

    // Validaciones básicas
    if (!formData.nombre.trim()) {
      setModalMessage("Por favor, ingresa tu nombre.");
      setIsError(true);
      setShowModal(true);
      setIsLoading(false);
      return;
    }

    if (!formData.email.trim() || !isValidEmail(formData.email)) {
      setModalMessage("Por favor, ingresa un correo válido.");
      setIsError(true);
      setShowModal(true);
      setIsLoading(false);
      return;
    }

    if (!formData.politica_privacidad) {
      setModalMessage("Debes aceptar la política de privacidad.");
      setIsError(true);
      setShowModal(true);
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_WORDPRESS_API_URL || "http://localhost"}/wp-json/balloon-ben/v1/club/subscribe`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Error al suscribirse. Intenta de nuevo.");
      }

      // Éxito
      setModalMessage(
        "¡Gracias por unirte! Pronto recibirás tus primeras sorpresas de Balloon & Ben."
      );
      setIsError(false);
      setShowModal(true);

      // Limpiar formulario
      setFormData({
        nombre: "",
        email: "",
        pais: "",
        noticias: false,
        ofertas: false,
        politica_privacidad: false,
      });
    } catch (error) {
      console.error("Error:", error);
      setModalMessage(error.message || "Error al suscribirse. Intenta de nuevo.");
      setIsError(true);
      setShowModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  const isValidEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };
  
  return (
    <div className="club-form-container">
      <div className="bat-container">
        <img src={Murcielago} alt="Murciélago" className="bat-image" />
      </div>

      <form className="club-form" onSubmit={handleSubmit}>
        <h2 className="Club-title">{titulo}</h2>

        <input
          type="text"
          name="nombre"
          placeholder="Tu Nombre"
          value={formData.nombre}
          onChange={handleInputChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Tu correo electrónico"
          value={formData.email}
          onChange={handleInputChange}
          required
        />
        <input
          type="text"
          name="pais"
          placeholder="Tu país"
          value={formData.pais}
          onChange={handleInputChange}
          required
        />

        <div className="checkbox-group">
          <p>¿Qué te gustaría recibir?</p>
          <label>
            <input
              type="checkbox"
              name="noticias"
              checked={formData.noticias}
              onChange={handleInputChange}
            />
            Noticias y eventos
          </label>
          <label>
            <input
              type="checkbox"
              name="ofertas"
              checked={formData.ofertas}
              onChange={handleInputChange}
            />
            Ofertas exclusivas
          </label>
        </div>

        <div className="authorization">
          <p>Autorización</p>
          <label>
            <input
              type="checkbox"
              name="politica_privacidad"
              checked={formData.politica_privacidad}
              onChange={handleInputChange}
              required
            />
            Acepto recibir correos de Balloon & Ben y estoy de acuerdo con la{" "}
            <a
              href="/politicas/aviso-de-privacidad-autorizacion-datos-personales"
              target="_blank"
              rel="noopener noreferrer"
            >
              política de privacidad
            </a>
            .
          </label>
        </div>

        <button type="submit" className="join-button" disabled={isLoading}>
          {isLoading ? "Procesando..." : "¡Quiero unirme al club!"}
        </button>
      </form>

      {showModal && (
        <div className="modal-overlay">
          <div className={`modal-content ${isError ? "modal-error" : ""}`}>
            <p>{modalMessage}</p>
            {!isError && (
              <img src={BalloonBenEmergente} alt="Balloon y Ben" className="modal-image" />
            )}
            <button className="close-btn" onClick={() => setShowModal(false)}>
              Listo
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default InscripcionClub;
